/**
 * Sorts an array of thoughts based on the specified criteria
 * @param {Array} thoughts - Array of thought objects to sort
 * @param {string} sortBy - Sorting criteria ('recent', 'importance', or 'chronological')
 * @returns {Array} - Sorted array of thoughts
 */
export const sortThoughts = (thoughts, sortBy) => {
    return [...thoughts].sort((a, b) => {
        if (sortBy === 'recent') {
            // Sort by timestamp (newest first)
            return new Date(b.timestamp) - new Date(a.timestamp);
        } else if (sortBy === 'importance') {
            // Sort by importance (highest first), then by timestamp for equal importance
            const importanceA = a.importance !== undefined ? a.importance : 0;
            const importanceB = b.importance !== undefined ? b.importance : 0;
            
            if (importanceB !== importanceA) {
                return importanceB - importanceA;
            } else {
                // Secondary sort by timestamp
                return new Date(b.timestamp) - new Date(a.timestamp);
            }
        } else if (sortBy === 'chronological') {
            // Sort by timestamp (oldest first)
            const timestampA = a.createdAt || a.timestamp || new Date(0);
            const timestampB = b.createdAt || b.timestamp || new Date(0);
            return new Date(timestampA) - new Date(timestampB);
        }
        return 0;
    });
}; 